import { Flow_0_0_2 } from '@flexus/core';

export const BUI_38: Flow_0_0_2 = {
	id: '38',
	name: 'awaiting_izinga_payment',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to confirm Izinga payment'
		}
	},
	startNode: '',
	nodes: {}
};
